import _regeneratorRuntime from "/home/myaccountconso/web/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/myaccountconso/web/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/home/myaccountconso/web/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
var __jsx = React.createElement;
import React, { useState } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import { registerUser, connectionError, makeLogin } from './userSlice';
import useInputState from '../hooks/forms/useInputState';
import useCheckboxState from '../hooks/forms/useCheckboxState';
import { FormValidator, ShowValidation } from '../utils/validation/FormValidator';
import { EmailField, PasswordField, PasswordConfirmationField, TermsField } from '../utils/validation/auth/AuthValidators';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import ErrorMessage from '../elements/ErrorMessage';
import styles from '../styles/login/LoginForm.module.css';

var SignupForm = function SignupForm(props) {
  var redirectUrl = props.redirectUrl,
      loginLink = props.loginLink,
      defaultEmail = props.defaultEmail;
  var router = useRouter();

  var _useState = useState(false),
      isLoading = _useState[0],
      editIsLoading = _useState[1];

  var _useInputState = useInputState(defaultEmail ? defaultEmail : ''),
      _useInputState2 = _slicedToArray(_useInputState, 3),
      email = _useInputState2[0],
      editEmail = _useInputState2[1],
      resetEmail = _useInputState2[2];

  var _useInputState3 = useInputState(""),
      _useInputState4 = _slicedToArray(_useInputState3, 3),
      password = _useInputState4[0],
      editPassword = _useInputState4[1],
      resetPassword = _useInputState4[2];

  var _useInputState5 = useInputState(""),
      _useInputState6 = _slicedToArray(_useInputState5, 3),
      passwordConfirmation = _useInputState6[0],
      editPasswordConfirmation = _useInputState6[1],
      resetPasswordConfirmation = _useInputState6[2]; // const [terms, editTerms, resetTerms] = useInputState(false);


  var _useCheckboxState = useCheckboxState(''),
      _useCheckboxState2 = _slicedToArray(_useCheckboxState, 2),
      isChecked = _useCheckboxState2[0],
      editIsChecked = _useCheckboxState2[1];

  var dispatch = useDispatch();
  var signupError = useSelector(function (state) {
    return state.user.error;
  }); //load validation rules for fields

  var ValidationRules = {
    email: EmailField,
    password: PasswordField,
    passwordConfirmation: {
      rule: PasswordConfirmationField,
      param: password
    },
    terms: TermsField
  }; //blur validation

  function validateFieldOnBlur(e) {
    var field = e.target;
    var value;

    if (field.type == 'checkbox') {
      value = field.checked ? field.value : false;
    } else {
      value = field.value;
    }

    var id = e.target.id;
    var res;

    if (typeof ValidationRules[id] == 'object') {
      res = ValidationRules[id].rule(value, ValidationRules[id].param);
    } else {
      res = ValidationRules[id](value);
    }

    ShowValidation(id, res);
  }

  var handleChangeCheckbox = function handleChangeCheckbox(e) {
    editIsChecked(e);
    validateFieldOnBlur(e);
  };

  var signinUser = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(email, password) {
      var resultAction, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return dispatch(makeLogin({
                email: email,
                password: password
              }));

            case 3:
              resultAction = _context.sent;
              response = unwrapResult(resultAction);

              if (response.status == true) {
                if (redirectUrl) {
                  router.push(redirectUrl);
                }
              }

              _context.next = 12;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              editIsLoading(false);
              dispatch(connectionError('Ups, nu ne putem conecta. Te rugam sa incerci mai tarziu.'));

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));

    return function signinUser(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  var handleSignup = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
      var validForm, resultAction, response;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              e.preventDefault();
              validForm = FormValidator('signupForm', ValidationRules);

              if (!validForm) {
                _context2.next = 19;
                break;
              }

              editIsLoading(true);
              _context2.prev = 4;
              _context2.next = 7;
              return dispatch(registerUser({
                email: email,
                password: password,
                password_confirmation: passwordConfirmation
              }));

            case 7:
              resultAction = _context2.sent;
              editIsLoading(false);
              response = unwrapResult(resultAction);

              if (!(response.status == true)) {
                _context2.next = 13;
                break;
              }

              _context2.next = 13;
              return signinUser(email, password);

            case 13:
              _context2.next = 19;
              break;

            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2["catch"](4);
              editIsLoading(false);
              dispatch(connectionError('Ups, avem o problemă. Te rugăm sa încerci mai târziu.'));

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[4, 15]]);
    }));

    return function handleSignup(_x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  var spinner = isLoading && __jsx(React.Fragment, null, __jsx(Spinner, {
    as: "span",
    animation: "grow",
    size: "sm",
    role: "status",
    "aria-hidden": "true"
  }), "Te rug\u0103m s\u0103 a\u0219tep\u021Bi...");

  var btnDisabled = isLoading && 'disabled';

  var signupBtn = __jsx(Button, {
    variant: "primary",
    type: "submit",
    className: "col-12",
    disabled: btnDisabled
  }, spinner, !isLoading && 'Creează un cont');

  var termsLink = __jsx(Link, {
    href: "".concat(process.env.NEXT_PUBLIC_WEB, "/termeni/generali")
  }, __jsx("a", {
    title: "Termeni Conso",
    target: "_blank"
  }, "Termenii de utilizare"));

  var privacyLink = __jsx(Link, {
    href: "".concat(process.env.NEXT_PUBLIC_WEB, "/termeni/date-personale")
  }, __jsx("a", {
    title: "Politica privind datele personale",
    target: "_blank"
  }, "Politica de confidentialitate"));

  var termsLabel = __jsx(React.Fragment, null, "Sunt de acord cu ", termsLink, " si ", privacyLink);

  var errorMessage = signupError && signupError.isArray ? __jsx("ul", null, signupError.map(function (e) {
    return __jsx("li", null, e);
  })) : signupError;

  var errorBox = signupError && __jsx("div", {
    className: "mb-3"
  }, __jsx(ErrorMessage, {
    title: "Eroare",
    message: errorMessage
  }));

  return __jsx(React.Fragment, null, errorBox, __jsx(Form, {
    onSubmit: handleSignup,
    id: "signupForm",
    method: "post"
  }, __jsx(Form.Group, {
    controlId: "email"
  }, __jsx(Form.Label, {
    className: styles.login
  }, "Email"), __jsx(Form.Control, {
    type: "text",
    name: "email",
    onChange: editEmail,
    onBlur: validateFieldOnBlur,
    value: email
  }), __jsx(Form.Text, {
    className: "helper",
    as: "div"
  })), __jsx(Form.Group, {
    controlId: "password"
  }, __jsx(Form.Label, {
    className: styles.login
  }, "Parol\u0103"), __jsx(Form.Control, {
    type: "password",
    name: "password",
    onChange: editPassword,
    value: password,
    onBlur: validateFieldOnBlur
  }), __jsx(Form.Text, {
    className: "helper",
    as: "div"
  })), __jsx(Form.Group, {
    controlId: "passwordConfirmation"
  }, __jsx(Form.Label, {
    className: styles.login
  }, "Repet\u0103 Parola"), __jsx(Form.Control, {
    type: "password",
    name: "password_confirmation",
    onChange: editPasswordConfirmation,
    value: passwordConfirmation,
    onBlur: validateFieldOnBlur
  }), __jsx(Form.Text, {
    className: "helper",
    as: "div"
  })), __jsx(Form.Group, {
    controlId: "terms",
    className: styles.checkboxCustom
  }, __jsx(Form.Check, {
    type: "checkbox",
    custom: true,
    label: termsLabel,
    className: styles.labelWrapper,
    checked: isChecked,
    onChange: handleChangeCheckbox,
    value: "accept"
  }), __jsx(Form.Text, {
    className: "helper",
    as: "div"
  })), signupBtn), loginLink && __jsx(React.Fragment, null, __jsx("hr", null), __jsx("p", {
    className: "mt-3"
  }, "Ai deja un cont? ", __jsx(Link, {
    href: "/login"
  }, __jsx("a", {
    title: "Conecteaz\u0103-te la contul Conso"
  }, "Conecteaz\u0103-te")), ".")));
};

export default SignupForm;